module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "cvi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/cvi.htm"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "als"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/als.htm"
    }
  }, [_vm._v("Also by Leila Aboulela")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "tp"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/tp.htm"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "cop"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/cop.htm"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ded"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ded.htm"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "fm"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/fm.htm"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p01.htm",
      "id": "p01"
    }
  }, [_vm._v("I Scimitar and Son")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p01a1.htm",
      "id": "p01a1"
    }
  }, [_vm._v("1. S"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("COTLAND")]), _vm._v(", D"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ECEMBER 2010")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p01a2.htm",
      "id": "p01a2"
    }
  }, [_vm._v("2. A"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("KHULGO, THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("AUCASUS")]), _vm._v(", 1839")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p01a3.htm",
      "id": "p01a3"
    }
  }, [_vm._v("3. A"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("KHULGO, THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("AUCASUS")]), _vm._v(", 1839")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p02.htm",
      "id": "p02"
    }
  }, [_vm._v("II The Days Before")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p02a1.htm",
      "id": "p02a1"
    }
  }, [_vm._v("1. S"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("COTLAND")]), _vm._v(", D"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ECEMBER")]), _vm._v(" 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p02a2.htm",
      "id": "p02a2"
    }
  }, [_vm._v("2. G"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("EORGIA")]), _vm._v(", J"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("UNE")]), _vm._v(" 1854")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p02a3.htm",
      "id": "p02a3"
    }
  }, [_vm._v("3. P"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ETERSBURG")]), _vm._v(", J"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("UNE")]), _vm._v(" 1854")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p02a4.htm",
      "id": "p02a4"
    }
  }, [_vm._v("4. D"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ARGO, THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("AUCASUS")]), _vm._v(", J"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("UNE")]), _vm._v(" 1854")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03.htm",
      "id": "p03"
    }
  }, [_vm._v("III Crossing the Frontier")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03a1.htm",
      "id": "p03a1"
    }
  }, [_vm._v("1. S"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("COTLAND")]), _vm._v(", D"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ECEMBER")]), _vm._v(" 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p03a2.htm",
      "id": "p03a2"
    }
  }, [_vm._v("2. G"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("EORGIA")]), _vm._v(", J"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ULY")]), _vm._v(" 1854")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p04.htm",
      "id": "p04"
    }
  }, [_vm._v("IV Further Than the Outpost")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p04a1.htm",
      "id": "p04a1"
    }
  }, [_vm._v("1. S"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("COTLAND")]), _vm._v(", D"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ECEMBER")]), _vm._v(" 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p04a2.htm",
      "id": "p04a2"
    }
  }, [_vm._v("2. G"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("EORGIA")]), _vm._v("/D"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("AGESTAN, JULY")]), _vm._v(" 1854")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p04a3.htm",
      "id": "p04a3"
    }
  }, [_vm._v("3. W"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ARSAW")]), _vm._v(", S"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("EPTEMBER")]), _vm._v(" 1854")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p05.htm",
      "id": "p05"
    }
  }, [_vm._v("V When the Sugarcane Grows")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p05a1.htm",
      "id": "p05a1"
    }
  }, [_vm._v("1. S"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("COTLAND")]), _vm._v(", D"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ECEMBER")]), _vm._v(" 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p05a2.htm",
      "id": "p05a2"
    }
  }, [_vm._v("2. D"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ARGO, THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("AUCASUS")]), _vm._v(", S"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("EPTEMBER")]), _vm._v(" 1854")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p05a3.htm",
      "id": "p05a3"
    }
  }, [_vm._v("3. D"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ARGO")]), _vm._v(", T"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("AUCASUS")]), _vm._v(", O"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("CTOBER")]), _vm._v(" 1854")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p06.htm",
      "id": "p06"
    }
  }, [_vm._v("VI A Glimmer Passes Through")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p06a1.htm",
      "id": "p06a1"
    }
  }, [_vm._v("1. S"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("COTLAND")]), _vm._v(", D"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ECEMBER")]), _vm._v(" 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p06a2.htm",
      "id": "p06a2"
    }
  }, [_vm._v("2. D"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ARGO, THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("AUCASUS")]), _vm._v(", N"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("OVEMBER")]), _vm._v(" 1854")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p06a3.htm",
      "id": "p06a3"
    }
  }, [_vm._v("3. S"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("T")]), _vm._v(" P"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ETERSBURG")]), _vm._v(", J"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ANUARY")]), _vm._v(" 1855")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p07.htm",
      "id": "p07"
    }
  }, [_vm._v("VII Homesickness Is Our Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p07a1.htm",
      "id": "p07a1"
    }
  }, [_vm._v("1. S"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("COTLAND")]), _vm._v(", D"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ECEMBER")]), _vm._v(" 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p07a2.htm",
      "id": "p07a2"
    }
  }, [_vm._v("2. L"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ONDON")]), _vm._v(", D"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ECEMBER")]), _vm._v(" 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p07a3.htm",
      "id": "p07a3"
    }
  }, [_vm._v("3. K"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("HASAVYURT, THE FRONTIER OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("HAMIL’S TERRITORY")]), _vm._v(", F"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("EBRUARY")]), _vm._v(" 1855")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p07a4.htm",
      "id": "p07a4"
    }
  }, [_vm._v("4. D"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ARGO")]), _vm._v("-V"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("EDDIN")]), _vm._v(", F"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("EBRUARY")]), _vm._v(" 1855")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p07a5.htm",
      "id": "p07a5"
    }
  }, [_vm._v("5. K"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("HASAVYURT")]), _vm._v(", M"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ARCH")]), _vm._v(" 1855")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p08.htm",
      "id": "p08"
    }
  }, [_vm._v("VIII A Thistle Twisted to One Side")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p08a1.htm",
      "id": "p08a1"
    }
  }, [_vm._v("1. K"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("HARTOUM")]), _vm._v(", D"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ECEMBER 2010")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p08a2.htm",
      "id": "p08a2"
    }
  }, [_vm._v("2. G"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("EORGIA")]), _vm._v(", M"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ARCH")]), _vm._v(" 1855")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p08a3.htm",
      "id": "p08a3"
    }
  }, [_vm._v("3. T"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("AUCASUS")]), _vm._v(", M"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ARCH")]), _vm._v(" 1855–A"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("PRIL")]), _vm._v(" 1856")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p08a4.htm",
      "id": "p08a4"
    }
  }, [_vm._v("4. G"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("EORGIA")]), _vm._v(", O"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("CTOBER")]), _vm._v(" 1856")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p08a5.htm",
      "id": "p08a5"
    }
  }, [_vm._v("5. T"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("AUCASUS")]), _vm._v(", M"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ARCH")]), _vm._v(" 1857–J"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ULY")]), _vm._v(" 1858")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p09.htm",
      "id": "p09"
    }
  }, [_vm._v("IX High Torn Banners")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p09a1.htm",
      "id": "p09a1"
    }
  }, [_vm._v("1. K"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("HARTOUM")]), _vm._v(", J"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ANUARY")]), _vm._v("–F"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("EBRUARY")]), _vm._v(" 2011")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p09a2.htm",
      "id": "p09a2"
    }
  }, [_vm._v("2. G"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("EORGIA")]), _vm._v(", S"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("UMMER")]), _vm._v("–A"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("UTUMN")]), _vm._v(" 1859")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p09a3.htm",
      "id": "p09a3"
    }
  }, [_vm._v("3. K"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ALUGA")]), _vm._v(", R"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("USSIA")]), _vm._v(", 1859–69")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p10.htm",
      "id": "p10"
    }
  }, [_vm._v("X The Castle Then a Tour")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p10a1.htm",
      "id": "p10a1"
    }
  }, [_vm._v("1. S"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("COTLAND")]), _vm._v(", F"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("EBRUARY")]), _vm._v("–M"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("AY")]), _vm._v(" 2011")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p11.htm",
      "id": "p11"
    }
  }, [_c('em', [_vm._v("Postscript")]), _vm._v(" Ghazi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/p11a1.htm",
      "id": "p11a1"
    }
  }, [_vm._v("1. M"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("AKKAH")]), _vm._v("/M"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("EDINA")]), _vm._v(", 1871")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/ack.htm",
      "id": "ack"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("CKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/back.htm",
      "id": "back"
    }
  }, [_vm._v("Back Cover")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340136e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 78
// module chunks = 0